import HtmlElementHelper from "../../Shared/Helpers/htmlElementHelper";
import * as Fingerprint from '../Shared/fingerprint';

window.addEventListener('DOMContentLoaded', (event) => {
    const buttonContinue = document.querySelector("#button-continue");
    if (buttonContinue) {
        buttonContinue.addEventListener('click', (event) => {
            const form = document.querySelector("#amountForm") as HTMLFormElement;
            const isQuickRegistrationRequired = form?.getAttribute("data-quickreg");

            if (isQuickRegistrationRequired === "True") {
                // quickregmodal.frommagento.js
                (window as any).bindQuickRegModal(event);
            } else {
                HtmlElementHelper.g_blockUI();
                form?.submit();
            }
        });
    }
    const inputFingerprint = document.querySelector('#input-fingerprint') as HTMLInputElement;
    if (inputFingerprint) {
        inputFingerprint.value = Fingerprint.getFingerprint();
    }
});
